import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import '../styles/bargraph.scss'


function bargraph() {

    const data = [
        { name: 'Tokyo', y: 7 },
        { name: 'New York', y: 4 },
        { name: 'Berlin', y: 3 },
        { name: 'London', y: 2 },
        { name: 'Tokyo', y: 8 },
        { name: 'New York', y: 9 },
        { name: 'Berlin', y: 5 },
        { name: 'London', y: 6},
      ];
      const options = {
        chart: {
          type: 'column',
          backgroundColor: '#191C23',
        },
        title: {
          text: 'Expenses Activity ',
          align: 'flex-start', 
          style: {
            
            color: '#FCFDFF', // set the color of the title
            textOutline: 'none', // remove the text outline of the title
          },
        },
        xAxis: {
          categories: data.map((item) => item.name),
          gridLineWidth: 0,
        
        
        },
        yAxis: {
          gridLineWidth: 0,
    minorGridLineWidth: 0,
    gridLineColor: 'transparent',
    minorGridLineColor: 'transparent',
          title: {
            text: 'Value',
          
           
          },
        },
        plotOptions: {
          column: {
            borderRadius: (0 , 0 ,0 ,6),
            pointPadding: .4, // set the padding between columns within a group
            groupPadding: .2, // set the padding between groups of columns
            borderColor: null,
            
          },
          color: 'transparent',
        },
      
        series: [
          {
            name: 'Value',
            data: data.map((item) => item.y),
            color: '#6964FF'
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                {
                  text: 'Custom Button',
                  onclick: function() {
                    alert('Custom button clicked!');
                  }
                }
              ]
            }
          }
        }
      };
  return (
    <div  > <HighchartsReact  highcharts={Highcharts} options={options} /></div>
  )
}

export default bargraph